// src/components/portfolio/PortfolioSection.js
import React from 'react';
import { usePortfolioState } from '../../hooks/usePortfolioState';
import PortfolioTree from './PortfolioTree';
import PortfolioModals from './PortfolioModals';

function PortfolioSection({ userId, selectedPortfolioId }) {
  const {
    portfolioData,
    symbolCache,  // symbolCache'i almayı ekledik
    loading,
    modalState,
    setModalState,
    handleAddCategory,
    handleAddAsset,
    handleCategorySubmit,
    handleAssetSubmit,
    handleDelete,
    handleAllocationChange
  } = usePortfolioState(userId, selectedPortfolioId);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col bg-white dark:bg-[#151934] rounded-lg shadow-sm p-4">
      <PortfolioTree 
        data={portfolioData}
        symbolCache={symbolCache}  // symbolCache'i prop olarak geçiyoruz
        onAddAsset={handleAddAsset}
        onAddCategory={handleAddCategory}
        onDelete={handleDelete}
        onAllocationChange={handleAllocationChange}
      />

      <PortfolioModals
        modalState={modalState}
        setModalState={setModalState}
        onCategorySubmit={handleCategorySubmit}
        onAssetSubmit={handleAssetSubmit}
        portfolioData={portfolioData} // Eklenen prop
      />
    </div>
  );
}

export default PortfolioSection;